import { Routes, Route, Navigate, Outlet } from "react-router-dom";
import { useState, useEffect, createContext } from "react";
import Rhyms from "./components/Rhyms/Rhyms";
import Admin from "./components/Dashboard/Admin/Admin";
import Users from "./components/Dashboard/Users/Users";
import Excel from "./components/Dashboard/ImportFromExcel";
import Login from "./components/LoginScreen/Login";
import ProtectedRoute from "./components/LoginScreen/ProtectedRoute";
import AddingUser from "./components/LoginScreen/AddAdminModal";
import Dashboard from "./components/Dashboard/Dashboard";
import Analyse from "./components/Dashboard/Analyse";
import Home from "./components/Home/Home"
import Albums from "./components/Rhyms/Albums"
import MobileApp from "./components/Dashboard/App/MobileApp"
import Privacy from "./components/Home/PrivacyPolicy"
import "./App.css";
import "./index.css";

export const ThemeContext = createContext();

function App() {
  // const Ip = "http://localhost/nourtune_back/admin";
  // const IpImg="http://localhost/nourtune_back";
  const Ip = "https://nourtune.com/admintune";
  const [admin, setAdmin] = useState();
  const [isDark, setIsDark] = useState(() => {
    const saved = localStorage.getItem("theme");
    return saved ? saved === "dark" : true; // Default dark
  });

  useEffect(() => {
    localStorage.setItem("theme", isDark ? "dark" : "light");
    if (isDark) {
      document.documentElement.classList.add("dark");
    } else {
      document.documentElement.classList.remove("dark");
    }
  }, [isDark]);

  useEffect(() => {
    const access = localStorage.getItem("nourtune_admin");
    setAdmin(access === "true"); 
  }, []);

  return (
    <ThemeContext.Provider value={{ isDark, setIsDark }}>
      <Routes>
        <Route path="/" element={<Home Ip={Ip} />} />
        <Route path="/admin" element={<Login Ip={Ip} />} />
        <Route path="/AddingUser" element={<AddingUser Ip={Ip} />} />
        <Route path="/privacy" element={<Privacy Ip={Ip} />} />

        <Route path="/dashboard" element={<Dashboard Ip={Ip}/>}>
          <Route index element={<Rhyms Ip={Ip}/>} /> 
          <Route path="rhyms" element={<Rhyms Ip={Ip}/>} />
          <Route path="admin" element={<Admin Ip={Ip}/>} />
          <Route path="users" element={<Users Ip={Ip}/>} />
          <Route path="excel" element={<Excel Ip={Ip}/>} />
          <Route path="analyse" element={<Analyse Ip={Ip}/>} />
          <Route path="albums" element={<Albums Ip={Ip}/>} />
          <Route path="mobileapp" element={<MobileApp Ip={Ip}/>} />
        </Route>
      </Routes>
    </ThemeContext.Provider>
  );
}

export default App;
